<template>
	<div class="w-full">
		<TabHeader
			:tabs="tabs"
			:current-tab-hash="currentTabHash"
			:change-tab="changeTab"
		/>
		<Tab
			:description="description"
			:current-tab-hash="currentTabHash"
			:current-tab-specification="currentTabSpecification"
			:size-guide-image="sizeGuideImage"
			:washing-instruction-image="washingInstructionImage"
		/>
	</div>
</template>

<script setup lang="ts">
import type { VariantParametric } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { Image } from "~/types/storyblok/storyblok";
import Tab from "./Tab.vue";
import TabHeader from "./TabHeader.vue";

interface Props {
	tabs: { name: string; value: string }[];
	currentTabHash: string;
	changeTab: (value: string) => string;
	description: string | undefined;
	currentTabSpecification: VariantParametric[] | undefined;
	sizeGuideImage?: Image;
	washingInstructionImage?: Image;
}

defineProps<Props>();
</script>
